import { unByKey } from "ol/Observable";
import { memo, useEffect } from "react";

import useAppSelector from "../utils/hooks/useAppSelector";

// Hide the controls elements when we scroll the bottom container
function ControlsHiddenListener({
  onChange,
}: {
  onChange: (hidden: boolean) => void;
}) {
  const map = useAppSelector((state) => state.map);
  useEffect(() => {
    const onScroll = () => {
      const controlElem = document.getElementById("map-controls");
      const bottomContainer = document.getElementById("bottom-container");
      if (!controlElem || !bottomContainer) {
        onChange(false);
        return;
      }
      if (!bottomContainer.closest(".tm-w-xs, .tm-w-s, .tm-w-m, .tm-w-l")) {
        onChange(false);
        return;
      }
      const controlBottom = controlElem.getBoundingClientRect().bottom;
      const bottomContainerTop = bottomContainer.getBoundingClientRect().top;

      onChange(bottomContainerTop < controlBottom);
    };

    const key = map?.on("change:size", () => {
      onScroll();
    });
    return () => {
      if (key) {
        unByKey(key);
      }
    };
  }, [map, onChange]);

  return null;
}

export default memo(ControlsHiddenListener);
